import { createReducer } from "@reduxjs/toolkit";
import { resetUpdateTransfer, updateTransfer } from "./update-transfer";
import type { UpdateState } from "@redux/state/shared-types";

const initialState: UpdateState = { justUpdatedId: null, processing: "idle" };

export const updateTransferReducer = createReducer<UpdateState>(initialState, builder => {
  builder.addCase(updateTransfer.fulfilled, (state, { meta }) => {
    return {
      ...state,
      justUpdatedId: meta.arg.id,
      processing: "success",
    };
  });
  builder.addCase(updateTransfer.pending, state => {
    return {
      ...state,
      processing: "pending",
    };
  });
  builder.addCase(updateTransfer.rejected, state => {
    return {
      ...state,
      processing: "failed",
    };
  });
  builder.addCase(resetUpdateTransfer, () => {
    return initialState;
  });
});
